import * as _ from 'lodash';
import React from 'react';
import { Button } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import { useFieldBulletinBoardEdit } from '../../services/fieldBulletinBoard/FieldBulletinBoardEditContext';

import { Confirmation, Information } from '../modals/common';

import { API_PUBLICATION_STATUS } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardForm.scss';

/**
 * 現場掲示板編集 フッター
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardFooterEdit() {
  const {
    getData,
    closeCompleteDialog,
    closeConfirmDialog,
    executePublish,
    getButtonDisableFlg,
    getErrorDialogProperty,
    getModalDisplayInfo,
    handlePublish,
    handleUpdateButtonClick,
    handleUpdateConfirmModalUpdateButtonClick,
  } = useFieldBulletinBoardEdit();

  const data = getData();
  const modalDisplayInfo = getModalDisplayInfo();
  const buttonDisableFlg = getButtonDisableFlg();
  const errorDialogProperty = getErrorDialogProperty();
  const updateButtontxt =
    data.bulletin_board_publication_status === API_PUBLICATION_STATUS.DRAFT
      ? messageUtility.getMessage('I-000-165-13')
      : messageUtility.getMessage('I-000-167-01');

  /**
   * エラーダイアログ用のタイトル
   * */
  const ErrorDialogTitle = () => {
    return (
      <React.Fragment>
        <ReportProblemOutlinedIcon
          sx={{ fill: '#d32f2f', verticalAlign: 'middle' }}
        />
        {errorDialogProperty.title}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className={`${Styles.footer}`}>
        <div className='form-group'>
          <div className={'btn-menu'}>
            <Button
              className='update-btn'
              disabled={buttonDisableFlg}
              onClick={() => handleUpdateButtonClick()}
              variant='outlined'
            >
              {updateButtontxt}
            </Button>
            <Button
              className='publish-btn'
              variant='contained'
              onClick={() => handlePublish()}
              disabled={buttonDisableFlg}
            >
              {messageUtility.getMessage('I-000-165-12')}
            </Button>
          </div>
        </div>
      </div>
      {/* 更新確認 */}
      <Confirmation
        visible={_.has(modalDisplayInfo, 'update') && modalDisplayInfo.update}
        title={messageUtility.getMessage('I-000-167-11')}
        message={messageUtility.getMessage('I-000-167-12')}
        confirmButtonText={messageUtility.getMessage('I-000-167-13')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={() => handleUpdateConfirmModalUpdateButtonClick()}
        onCancel={() => {
          closeConfirmDialog();
        }}
      />
      {/* 更新完了 */}
      <Information
        buttonText={messageUtility.getMessage('I-000-017')}
        message={messageUtility.getMessage('I-000-167-03')}
        onClose={() => closeCompleteDialog()}
        title={messageUtility.getMessage('I-000-167-02')}
        visible={
          _.has(modalDisplayInfo, 'updateComplete') &&
          modalDisplayInfo.updateComplete
        }
      />
      {/* 公開確認 */}
      <Confirmation
        visible={_.has(modalDisplayInfo, 'publish') && modalDisplayInfo.publish}
        title={messageUtility.getMessage('I-000-165-04')}
        message={messageUtility.getMessage('I-000-165-05')}
        confirmButtonText={messageUtility.getMessage('I-000-165-08')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={() => executePublish()}
        onCancel={() => {
          closeConfirmDialog();
        }}
      />
      {/* 公開予約確認 */}
      <Confirmation
        visible={
          _.has(modalDisplayInfo, 'publishReserve') &&
          modalDisplayInfo.publishReserve
        }
        title={messageUtility.getMessage('I-000-165-09')}
        message={messageUtility.getMessage('I-000-165-10')}
        confirmButtonText={messageUtility.getMessage('I-000-165-11')}
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        onConfirm={() => executePublish()}
        onCancel={() => {
          closeConfirmDialog();
        }}
        multilineText
      />
      {/* 公開完了 */}
      <Information
        visible={
          _.has(modalDisplayInfo, 'publishComplete') &&
          modalDisplayInfo.publishComplete
        }
        title={messageUtility.getMessage('I-000-165-07')}
        message={messageUtility.getMessage('I-000-165-06')}
        onClose={() => closeCompleteDialog()}
        buttonText={messageUtility.getMessage('I-000-017')}
      />
      {/* エラーダイアログ */}
      <Information
        visible={_.has(modalDisplayInfo, 'error') && modalDisplayInfo.error}
        title={<ErrorDialogTitle />}
        message={errorDialogProperty.message}
        onClose={() => closeConfirmDialog()}
        buttonText={messageUtility.getMessage('I-000-017')}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardFooterEdit.jsx